import { Typography } from "@mui/material";

const ScoutDashboard = () => {
    return (
        <Typography>Scout/Coach Dashboard</Typography>
    )
}

export default ScoutDashboard;
